const buttonSizeVariants = {
    small: {
        height: 30,
        fontSize: 13,
        padding: "0 11px",
        icon: 13,
        iconPadding: 5,
    },
    medium: {
        height: 40,
        fontSize: 15,
        padding: "0 21px",
        icon: 15,
        iconPadding: 7,
    },
    large: {
        height: 48,
        fontSize: 20,
        padding: "0 30px",
        icon: 20,
        iconPadding: 9,
    },
};

export default buttonSizeVariants;
